import {
    SimpleLookupModel,
    Validatable,
    UploadFileModel,
    UserModel
} from "@/core/models";

import {
    CourseExamSubmissionType,
    AssessmentExpiryDurations
} from "@/core/constants";

export class CourseModel extends Validatable {
    courseId: number;
    name: string = "";
    code: string = "";
    createDate: Date;
    lastUpdateDate: Date;
    levelId: number;
    secondaryEducatorLevelId: number;
    strandId: number;
    deliveryTypeId: number;
    courseCertificationAuthorityId: number;
    certificateDurationInMonths: number;
    audienceId: number;
    version: string = "";
    maxNumberOfQuestionsPerPage: number | undefined = undefined;
    courseExamSubmissionTypeId: number = CourseExamSubmissionType.MultipleSubmissionsUntilAllCorrect;
    examPassMark: number | undefined = undefined;
    timeLimitInMinutes: number | undefined = undefined;
    preventResitDurationInDays: number | undefined = undefined;
    umbracoNodeId: number | undefined = undefined;
    assessmentExpiryInMonths: number = AssessmentExpiryDurations.Default;
    prerequisites: CourseCollectionModel[] = [];
    replacesCourseId: number | undefined = undefined;
    replacementFamilyId: number | undefined = undefined;
    replacedByCourseId: number | undefined = undefined;
    replacedByCourseName: string | undefined = undefined;
    inactivateReplacedCourse: boolean = false;
}

export class CourseLookupModel {
    levels: SimpleLookupModel[];
    strands: SimpleLookupModel[];
    deliveryTypes: SimpleLookupModel[];
    courseCertificationAuthorities: SimpleLookupModel[];
    audience: SimpleLookupModel[];
    courseExamSubmissionTypes: SimpleLookupModel[];
    activeCourses: SimpleLookupModel[];
}

export class CourseCollectionModel {
    courseId: number;
    code: string;
    name: string;
    codeAndName: string;
    isActive: boolean;
    strand: string;
    level: string;
    replacementFamilyId: number | undefined;
}

export class CourseRequiredForModel {
    requiredFor?: CourseCollectionModel;
    courses: CourseCollectionModel[] = [];
}

export class CourseCertificateModel {
    courseId: number;
    localeId: number;
    localeName: string;
    file: UploadFileModel | null;
    updatedByUser: UserModel | null;
    dateUpdated: Date;
}

export class CourseMaterialModel {
    courseMaterialId: number | null;
    courseId: number;
    localeId: number;
    locale: string;
    isActive: boolean;
    filename: string = "";
    displayFilename: string = "";
    addedByUser: UserModel | null;
    dateAdded: Date;
    updatedByUser: UserModel | null;
    dateUpdated: Date;
}

export class CoursePackageModel extends Validatable {
    coursePackageId: number | null;
    courseId: number = 0;
    locale: string;
    localeId: number;
    version: string = ""; // Max length: 16
    filename: string = "";
    url: string = ""; // Max length: 512
    blobName: string = "";
    isActive: boolean = true;
    addedOn: Date;
    addedByUserId: number;
    updatedOn: Date;
    updatedByUserId: number;
}

export class CoursePackageCollectionModel {
    coursePackageId: number = 0;
    courseId: number = 0;
    localeId: number = 0;
    version: string = "";
    localCode: string = "";
    filename: string = "";
    url: string = "";
    privateUrl: string = "";
    isActive: boolean = true;
    addedOn: Date;
    addedByUserId: number = 0;
    addedByUser: string = "";
}